import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import Mask from 'utils/src/mask';
import FitFormTolls from "utils/src/fitinsur-form-tolls";

import ContentCard from 'components/ContentCard/index';
import { Col, Row } from 'components/Grid';
import Label from "components/Form/Label";
import CheckBox from "components/Form/CheckBox";
import { RadioButtonGroup } from "components/Form/Radio/index";
import { Button } from 'components/index';
import Subtitle from 'components/SubTitle';
import BrokingSummary1 from 'components/BrokingSummary1';
import LogoAkad from 'components/Icon/png/akad_seguros_logo.png';
import ImgLogo from "components/Icon/png/AIO-logo.png";
import Modal from 'components/Modal/index';
import InputField from 'components/Form/InputField';
import {
  Container,
  Title,
  Subtitle2,
  Head,
  Content,
  ButtonContainer,
  Fieldset,
  CardInfo,
  Logo,
  InsurerLogo,
  Line,
  AceptContainer,
  CalendarContainer
} from './styles';


export default function PaymentPage(props) {

  const [validation, setValidation] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [sentCode, setSentCode] = useState(false);
  const [insurer, setInsurer] = useState('');
  const [questions, setQuestions] = useState([]);
  const [quote, setQuote] = useState({
    idOperation: "",
    email: "",
    proponent: "",
    cpfOrCnpj: "",
    typeInsurance: "",
    CRO: "",
    annualGrossRevenue: "",
    claimsTotal: "",
    latestComplaints: "",
    damageCaused: "",
    effectiveDate: "",
    retroactivity: "",
    typeRisk: "",
    product_plans: "",
    idDomainStatus: "",
    coverages: [],
    limits: [],
    payments: [],
    installmentNumber: null,
    personType: null,
  });
  const [plan, setPlan] = useState(null);
  const [statusOperation, setStatusOperation] = useState(null);
  const [option, setOption] = useState(props.location.state?.option);
  const idProduct = props.match.params?.idProduct;
  const idOperation = props.match.params?.idOperation;

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const fitinsur = new FitinsurAPI();
  const fitForm = new FitFormTolls();
  const mc = new MessageCenter();
  const history = useHistory();
  const formik = useRef(Formik);
  // constante com ids e descrição dos campos do formulário
  const fieldQuestions = {
    telefone: "209",
    CEP: "210",
    logradouro: "211",
    numero: "212",
    complemento: "213",
    cidade: "214",
    estado: "215",
    pep: "217",
    frmPagamento: "228",
    parcelamento: "229",
    dtparcela: "231",
  };

  const initialvalues = {
    confirmData: false,
    acceptTerms: false,
    209: '',
    210: '',
    211: '',
    212: '',
    213: '',
    214: '',
    215: '',
    217: '',
    228: '',
    229: '',
    231: '',
  };

  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
    "Domingo",
  ];
  const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

  const getValidation = () => {
    console.log("chamando validations")
    let val = yup.object().shape({
      228: fitForm.verifyRequired(fieldQuestions.frmPagamento, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      217: fitForm.verifyRequired(fieldQuestions.pep, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      209: fitForm.verifyRequired(fieldQuestions.telefone, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      210: fitForm.verifyRequired(fieldQuestions.CEP, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      214: fitForm.verifyRequired(fieldQuestions.cidade, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      212: fitForm.verifyRequired(fieldQuestions.numero, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      231: fitForm.verifyRequired(fieldQuestions.dtparcela, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      211: fitForm.verifyRequired(fieldQuestions.logradouro, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      215: fitForm.verifyRequired(fieldQuestions.estado, questions)
        ? yup.string().required('* Campo Obrigatório')
        : (yup.string().notRequired()),
      /* confirmData: yup.bool().required(() => { mc.error("aceite os termos"); }),
      acceptTerms: yup.bool().required(() => { mc.error("aceite os termos"); }) */

    });
    setValidation(val);
  }

  const handleSubmit = (values) => {

    console.log(values);
    if (formik.current.values["confirmData"] === false || formik.current.values["acceptTerms"] === false) {
      mc.error("É necessário aceitar os termos e condições e confirmar a revisão dos Dados");
      return;
    };
    if (!formik.current.values["verificationCode"] || formik.current.values["verificationCode"].length < 7) {
      mc.error("É necessário informar o código de emissão");
      return;
    }

    let personQst = [];
    let paymentQst = [];

    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction5(idOperation, values.verificationCode, false)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error("Código Inválido")
          loading.stop();
          return;
        }

        //Montando questionarios com respostas
        questions.map(item => {
          let filteredItem = Object.keys(values).includes(item.idQuestion.toString());
          console.log("filteredItem: ", filteredItem);

          if (filteredItem) {
            console.log("Item: ", item);
            let idAnswer = values[item.idQuestion].idAnswerOption ? values[item.idQuestion].idAnswerOption : null;
            let dsAnswer = values[item.idQuestion].dsAnswerOption ? values[item.idQuestion].dsAnswerOption : values[item.idQuestion];

            let qst = {
              idAnswerOption: idAnswer,
              idDomainPersonRole: item.idDomainPersonRoleQuestion,
              idQuestion: Number(item.idQuestion),
              idQuestionnaire: item.idQuestionaire,
              questionDomain: item.idDomainQuestion,
              textQuestionAnswer: dsAnswer
            };

            if (item.idQuestionaire == 28) {
              // person questionnarie
              if (qst.idQuestion === 155) {
                let unMaskZipCode = Mask.numbers(values[item.idQuestion]);
                qst.textQuestionAnswer = unMaskZipCode;
              }
              personQst.push(qst);
            }
            if (item.idQuestionaire == 30) {
              // payment questionnarie
              paymentQst.push(qst);
            }
            console.log("Qst: ", qst);
          }
        });

        //Endereço do cliente
        let adress = {
          zipcode: values[fieldQuestions.CEP],
          city: values[fieldQuestions.cidade],
          street: values[fieldQuestions.logradouro],
          complemento: values[fieldQuestions.complemento],
          num: values[fieldQuestions.numero],
          uf: values[fieldQuestions.estado],
        };

        const body = {
          coverageList: plan.coverageItems,
          coverageListSelected: null,
          firstInstallmentDate: stringToDate(values[fieldQuestions.dtparcela]),
          idPlanCoverage: null,
          //id_personInsured: personRole.find(item => item.idPersonRole === 4).idPerson,
          id_product: idProduct,
          id_product_list: [],
          idProductPlan: plan.idProductPlan,
          idquoteop: idOperation,
          paymentMode: values[fieldQuestions.frmPagamento].dsAnswerOption,
          premium: plan.coverageAmount,
          selectedLim: plan.coverageLimit,
          //coverageAmountTaxLess: (plan.coverageAmountTaxLess + plan.coverageComission),//BUGFIX57 ajuste para exibição do valor correto no certificado de emissao
          coverageAmountTaxLess: (plan.coverageAmount - plan.coverageTax), // issue fitinsur/fitinsur-aio#87
          planOption: option,
          adress: adress,
          email: quote.email,
          cpfOrCnpj: Mask.cpfCnpj(quote.cpfOrCnpj),
          proponent: quote.proponent,
          effectiveDate: stringToDate(quote.effectiveDate),
          retroactivity: quote.retroactivity,
          revenue_annual: quote.annualGrossRevenue,
          deductible: plan.deductibleDescription,
          coverageTax: plan.coverageTax,
          //installment_number: values.planPayment ? values.planPayment : '7X sem juros = 0+7 de R$ 110,72',
          installment_number: quote?.installmentNumber?.answer,
          payment: paymentQst,
          persons: personQst
        };

        console.log("body issued: ", body);

        fitinsur.setAuthToken(authContext.token);
        //Submetendo questionario de Payment
        fitinsur.requestAddAction4(paymentQst, idOperation)
          .then(data => data.json())
          .then(response => {
            if (response.ret_code != 200) {
              mc.error(`${response.ret_msg_details}`);
              console.log(response.JSON.stringify());
              loading.stop();
              return;
            }
            // Submetendo Issue
            fitinsur.requestIssueAction(body)
              .then(data => data.json())
              .then(response => {
                if (response[0].ret_code != 200) {
                  mc.error(`${response.ret_msg_details}`);
                  console.log(response.JSON.stringify());
                  loading.stop();
                  return;
                }
                mc.success(`Seguro enviado com sucesso`);
                loading.stop();
                history.replace(`/embed/aio/issue/${idProduct}/${response[0].id_operation}`);
              })
              .catch(err => {
                console.log(err);
                loading.stop();
              });
          })
          .catch(err => console.log(err));
      })
      .cath(error => {
        console.log(JSON.stringify(error));
        mc.error("Erro ao processar solicitação")
      })
      .finally(() => {
        loading.stop();
      });
  };

  const handleSend = () => {
    loading.start();
    console.log("auth context-> ", authContext.token)
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction5(idOperation, null, true)
      .then((response) => response.json())
      .then((data) => {
        if (data.ret_code !== 200) {
          console.log(data.ret_msg);
          mc.error("Erro ao enviar o Código, tente novamente")
          return;
        };
        mc.success(sentCode ? "Código Re-enviado!" : "Código Enviado!")
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setSentCode(true);
        loading.stop();
      });
  }

  function getDisableDate() {
    let dateBefore = new Date();
    let dateAfter = new Date();
    let weekday;
    let disableDate = { after: undefined, before: undefined };

    dateBefore.setDate(dateBefore.getDate() + 10);
    console.log(dateBefore);

    weekday = dateBefore.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
      dateBefore.setDate(dateBefore.getDate() + 2)
      : weekday == 0 && dateBefore.setDate(dateBefore.getDate() + 1);

    disableDate.before = dateBefore;

    dateAfter.setDate(dateAfter.getDate() + 30)

    weekday = dateAfter.getDay();
    console.log("dia da semana", weekday)

    weekday == 6 ?
      dateAfter.setDate(dateAfter.getDate() + 2)
      : weekday == 0 && dateAfter.setDate(dateAfter.getDate() + 1);

    console.log(dateAfter);
    disableDate.after = dateAfter;

    return disableDate;
  }

  const dayClick = (day, modifiers = {}) => {
    console.log("data", day);
    console.log("Mod", modifiers);
    if (modifiers.disabled == true) {
      return;
    }
    let dt = new Date(day);
    const stringdate = dt.toLocaleDateString('en-GB');
    formik.current.setFieldValue(fieldQuestions.dtparcela, stringdate)
    setShowCalendar(false);
  }

  const stringToDate = (string) => {
    let parts = string.split('/');
    let date = new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
    console.log('data formatada', date);
    return date;
  }

  const handleGetZipCode = (zipcode) => {

    loading.start();
    const aux = Mask.numbers(zipcode);
    console.log("zipconde encoded", aux)
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetAdressByZipCode(aux)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error(`${response.ret_msg_details}`);
          console.log(response.JSON.stringify());
          loading.stop();
          return;
        }
        console.log('resultado Cep', response.ret_value);
        formik.current.setFieldValue(fieldQuestions.CEP, Mask.cep(response.ret_value.ZIP_CODE));
        formik.current.setFieldValue(fieldQuestions.cidade, response.ret_value.CITY);
        formik.current.setFieldValue(fieldQuestions.logradouro, response.ret_value.LONG_STREET_NAME);
        formik.current.setFieldValue(fieldQuestions.estado, response.ret_value.STATE);
        formik.current.setFieldValue('neighborhood', response.ret_value.DISTRICT);
        loading.stop();
      })
      .catch(err => {
        loading.stop();
        console.log(err)
      });

  };

  const handleCnpjAdress = (value) => {

    if (value == 'true') {
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestSerproCnpj(quote.cpfOrCnpj)
        .then(data => data.json())
        .then(response => {
          if (response.ret_code !== 200) {
            mc.error(`${response.ret_msg_details}`);
            console.log(response.JSON.stringify());
            loading.stop();
            return;
          }
          const { endereco } = response.ret_value;
          formik.current.setFieldValue(fieldQuestions.CEP, Mask.cep(endereco.cep));
          formik.current.setFieldValue(fieldQuestions.cidade, endereco.municipio.descricao);
          formik.current.setFieldValue(fieldQuestions.logradouro, endereco.logradouro);
          formik.current.setFieldValue(fieldQuestions.complemento, endereco.complemento);
          formik.current.setFieldValue(fieldQuestions.numero, endereco.numero);
          formik.current.setFieldValue(fieldQuestions.estado, endereco.uf);
          formik.current.setFieldValue(fieldQuestions.neighborhood, endereco.bairro);

          loading.stop();
        })
        .catch(err => {
          console.log(err);
          loading.stop();
        });
    } else {
      formik.current.setFieldValue(fieldQuestions.CEP, '');
      formik.current.setFieldValue(fieldQuestions.cidade, '');
      formik.current.setFieldValue(fieldQuestions.logradouro, '');
      formik.current.setFieldValue(fieldQuestions.complemento, '');
      formik.current.setFieldValue(fieldQuestions.numero, '');
      formik.current.setFieldValue(fieldQuestions.estado, '');
      formik.current.setFieldValue(fieldQuestions.neighborhood, '');
    }

  };

  function handleSelect(field) {
    formik.current.values[field] === true ? formik.current.setFieldValue(field, false)
      : formik.current.setFieldValue(field, true);
  }

  const changePlan = () => { history.push(`/embed/aio/plans/${idProduct}/${idOperation}`) };

  const getPayment = (insurer, coverageAmount) => {

    let installmentTotal;
    let options = [];
    installmentTotal = insurer === "Fator" ? 5 : 7;

    for (let index = 0; index < installmentTotal; index++) {

      let installmentValue = coverageAmount / (index + 1);
      let option = {
        label: index === 0 ? `Á vista` : `${index + 1}x Sem Juros de ` + `${Mask.currency({
          value: installmentValue,
          lang: "pt-br",
          currency: 'BRL',
          style: 'currency'
        })}`,
        //label: index === 0 ? `Á vista` : `${index + 1}x Sem Juros`, // de ${coverageAmount / (index+1)}
        value: `${index + 1}`
      };

      //20210314 - minor fix - error "options not iterable" no componente selectField
      if (insurer === "Argo" && installmentValue < 100) {
        //return;
      } else {
        options.push(option);
      }
      //options.push(option);
    };

    return options;
  };

  useEffect(() => {
    getValidation();
  }, [questions])

  useEffect(() => {
    async function requestGetQuoteFormatted() {
      if (authContext.status !== true) {
        mc.error("Usuário não autenticado");
        history.push('/embed/aio/info');
        return;
      }
      getValidation();
      loading.start();
      fitinsur.setAuthToken(authContext.token);
      fitinsur
        .requestGetQuote(props.match.params.idProduct, props?.match?.params?.idOperation)
        .then((x) => x.json())
        .then((response) => {
          if (response.ret_code != 200) {
            mc.error(response.ret_msg_details);
            return loading.stop();
          }
          const { ret_value } = response;
          const getUniqObjBeetweenSames = (array) =>
            array
              .map((item) => ({
                answer: item.answer,
                idQuestion: item.idQuestion,
                questionDescription: item.dsQuestion,
                questionBehavior: item.behavior,
                questionDomain: item.idDomainQuestion,
                ...item
              }))
              .filter(
                (item, pos, self) =>
                  self.findIndex(
                    (v) =>
                      v.answer === item.answer &&
                      item.idQuestion == v.idQuestion
                  ) === pos
              );
          const risks = getUniqObjBeetweenSames(ret_value.risks);
          const operations = getUniqObjBeetweenSames(ret_value.operations);
          const payments = getUniqObjBeetweenSames(ret_value.payments);
          const persons = getUniqObjBeetweenSames(ret_value.persons);

          //const questionaries = [...questions, ...payments, ...persons, operations];
          const questionaries = [
            ...operationContext.add_response.formPaymentQuestionnaire,
            ...operationContext.add_response.personQuestionnaire,
            ...operationContext.add_response.riskQuestionnaire,
            ...operationContext.add_response.operationQuestionnaire,
          ];

          setQuestions(questionaries);
          setStatusOperation(ret_value.operation.idDomainStatus);
          let planSelect = ret_value.operation.idProductPlan;
          const searshplan = ret_value.resultProductPlans.product_plan.find(plans => plans.id_product_plan === planSelect)
          const SelectedPlanName = searshplan.product_plan_name;
          SelectedPlanName.indexOf('Argo') > 0 ? setInsurer('argo') : setInsurer('fator');
          const mapCoverages = ret_value.resultProductPlans.coverageCalc
            .map((item) => [
              ...item.coverageCalc.map((coverage) => ({
                ...coverage,
                idProductPlan: item.id_product_plan,
              })),
            ])
            .flat();
          const flatCoverages = mapCoverages.map((item) => item.coverageLimit);
          const limits = flatCoverages.filter(
            (item, index, self) => self.indexOf(item) == index
          );
          const coverages = limits.map((limit) => {
            const plans = mapCoverages
              .map((item) => (item.coverageLimit == limit ? item : false))
              .filter(Boolean);
            return {
              limit,
              plans,
            };
          });
          setQuote({
            idOperation: ret_value.idOperation,
            proponent: ret_value.persons.find((item) => item.idQuestion == 207)
              .answer,
            email: ret_value.persons.find((item) => item.idQuestion == 206)
              .answer,
            cpfOrCnpj: ret_value.persons.find((item) => item.idQuestion == 205)
              .answer,
            effectiveDate: risks.find(({ idQuestion }) => idQuestion == 226)
              .answer,
            retroactivity: risks.find(({ idQuestion }) => idQuestion == 227)
              .answer,
            typeInsurance: risks.find(({ idQuestion }) => idQuestion == 218)
              .answer,
            CRO: ret_value.persons.find(({ idQuestion }) => idQuestion == 216)
              .answer,
            claimsTotal: risks.find(({ idQuestion }) => idQuestion == 222)
              .answer,
            latestComplaints: risks.find(({ idQuestion }) => idQuestion == 223)
              .answer,
            damageCaused: risks.find(({ idQuestion }) => idQuestion == 224)
              .answer,
            typeRisk: risks.find(({ idQuestion }) => idQuestion == 219)
              .answer,
            annualGrossRevenue: risks.find(({ idQuestion }) => idQuestion == 220)
              .answer,
            personType: ret_value.persons.find((item) => item.idQuestion == 232)
              .idAnswerOption,
            product_plans: ret_value.resultProductPlans.product_plan,
            idDomainStatus: ret_value.operation.idDomainStatus,
            coverages,
            limits,
            payments,
            installmentNumber: payments.find(({ idQuestion }) => Number(idQuestion) == Number(fieldQuestions.parcelamento))
          });
          setPlan(ret_value.operation.metadata.currentPlan);
          setOption(ret_value.operation.metadata.optionLabel);
          loading.stop();
        })
        .catch((e) => {
          loading.stop();
          console.log(e);
        });
    };
    requestGetQuoteFormatted();
  }, []);

  return (
    <Container>
      <Head>
        <Row>
          <Col className="d-sm-none" style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
            <Logo user={authContext.username}></Logo>
          </Col>
          <Col sm={12}>
            <Title>Estamos Quase Finalizando</Title>
            <Subtitle2>RESPONSABILIDADE CIVIL PROFISSIONAL DENTISTAS</Subtitle2>
          </Col>
        </Row>
        <Logo user={authContext.username} className="d-none d-sm-block p-0 p-md-2"></Logo>
      </Head>

      <Content>
        <Subtitle
          idProduct={idProduct}
          stage={3}
          idOperation={idOperation}
          statusOperation={statusOperation}
          activeColor={Colors.PRIMARY}
          cantGoBack={true}
        />
        <BrokingSummary1 data={quote} />
        <Modal visible={showTerms} setVisible={setShowTerms}>
          <h4>Termos e Condições</h4>
          <p>
            Declaro que li e estou de acordo com todas as condições acima informadas, assim como de acordo com os termos e condições dessa proposta, com as Condições Gerais, com a Política de Privacidade e com o envio das informações da plataforma da AIO Corretora.
          </p>
          <p>
            A seguradora fica autorizada a fazer qualquer investigação ou pergunta relacionada ao risco, na medida em que julgue necessária.
          </p>
          <AceptContainer>
            <Button primary onClick={() => {
              formik.current.setFieldValue('acceptTerms', true);
              setShowTerms(false)
            }}>
              ACEITAR
            </Button>
          </AceptContainer>
        </Modal>

        <Formik
          initialValues={initialvalues}
          onSubmit={(values) => handleSubmit(values)}
          innerRef={formik}
          validationSchema={validation}
        >
          {(formikProps) => (
            <Form>
              {/* <Modal show={showTerms}> */}
              <Row>
                <Col md={3}>
                  <ContentCard
                    title={`OPÇÃO ${option}`}
                    noBorder
                    noPadding
                    customShadow={`box-shadow: 0px 8px 12px 0px ${Colors.GRAY[4]};`}
                    rightTitle="Alterar"
                    action={changePlan}
                    color={Colors.TITLE}
                  //mr={12}
                  >

                    <Col md={12}>
                      <InsurerLogo src={LogoAkad} />
                      <Label>
                        Limite (Valor Segurado):
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          value: plan.coverageLimit,
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        Prêmio Líquido
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          //value: (plan.coverageAmountTaxLess + plan.coverageComission),
                          value: (plan.coverageAmount - plan.coverageTax),
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        IOF
                      </Label>
                      <label>{plan && Mask.currency({
                        value: plan.coverageTax,
                        lang: "pt-br",
                        currency: 'BRL',
                        style: 'currency'
                      })}</label>
                      <Label>
                        Prêmio Total (Valor a ser Pago)
                      </Label>
                      <label>
                        {plan && Mask.currency({
                          value: plan.coverageAmount,
                          lang: "pt-br",
                          currency: 'BRL',
                          style: 'currency'
                        })}
                      </label>
                      <Label>
                        Franquia
                      </Label>
                      <label>{plan && plan.deductibleDescription}</label>
                      {/* <label>plan.payment adicionar parametro do pagamento 7X sem juros = 0+7 de R$ 110,72</label>*/}
                      {
                        /*
                      <Field
                        name="planPayment"
                        placeholder="Parcelamento"
                        label="Parcelamento Selecionado:"
                        component={SelectField}
                        options={getPayment(insurer === 'argo' ? 'Argo' : 'Fator', plan?.coverageAmount)}
                      />                        
                        */
                      }
                      <Label>
                        Parcelamento Selecionado:
                      </Label>
                      <label>{quote?.installmentNumber?.answer}</label>
                    </Col>
                  </ContentCard>
                </Col>

                <Col md={9}>
                  <ContentCard
                    title="Dados de Pagamento"
                    noBorder
                    customShadow={`box-shadow: 0px 8px 12px 0px ${Colors.GRAY[4]};`}
                    color={Colors.TITLE}
                  >
                    <Fieldset>
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.frmPagamento}
                            label={fitForm.getDsQuestion(fieldQuestions.frmPagamento, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.frmPagamento, questions)}
                            options={fitForm.verifyOptions(fieldQuestions.frmPagamento, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.frmPagamento, questions)}

                          />
                        </Col>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.dtparcela}
                            label={fitForm.getDsQuestion(fieldQuestions.dtparcela, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.dtparcela, questions)}
                            value={formikProps.values[fieldQuestions.dtparcela]}
                            rightIcon="calendar"
                            rightIconClick={() => setShowCalendar(!showCalendar)}
                            readOnly
                            isRequired={fitForm.verifyRequired(fieldQuestions.dtparcela, questions)}
                          />
                          {showCalendar && <CalendarContainer>
                            <DayPicker
                              style
                              disabledDays={[
                                getDisableDate(),// { daysOfWeek: [0, 6] }
                              ]}
                              showOutsideDays
                              onDayClick={dayClick}
                              months={MONTHS}
                              weekdaysLong={WEEKDAYS_LONG}
                              weekdaysShort={WEEKDAYS_SHORT}
                              firstDayOfWeek={0}
                              fixedWeeks
                            />
                          </CalendarContainer>}
                        </Col>
                      </Row>
                    </Fieldset>
                    <Fieldset>
                    {quote.personType === 2532 ?
                        <Row>
                          <Line />
                          <Col md={10}>
                            <Field
                              name='endCad'
                              label='O endereço de cadastro é o mesmo do CNPJ?'
                              component={RadioButtonGroup}
                              options={[{ label: 'Sim', value: 'true' }, { label: 'Não', value: 'false' }]}
                              onChange={(value) => {
                                quote.personType === 2532 && handleCnpjAdress(value);
                                console.log(quote);
                              }}
                              row
                            />
                          </Col>
                        </Row>
                        : <Row><Line /></Row>}
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.CEP}
                            label={fitForm.getDsQuestion(fieldQuestions.CEP, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.CEP, questions)}
                            onChange={(value) => formikProps.setFieldValue(fieldQuestions.CEP, Mask.cep(value))}
                            value={formikProps.values[fieldQuestions.CEP]}
                            rightIconClick={() => {
                              handleGetZipCode(formikProps.values[fieldQuestions.CEP]);
                              console.log("valorzip", formikProps.values[fieldQuestions.CEP])
                            }}
                            isRequired={fitForm.verifyRequired(fieldQuestions.CEP, questions)}

                            readOnly={formikProps.values.endCad === 'true' &&
                              quote.personType === 2532
                              ? true
                              : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={10}>
                          <Field
                            name={fieldQuestions.logradouro}
                            label={fitForm.getDsQuestion(fieldQuestions.logradouro, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.logradouro, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.logradouro, questions)}

                            readOnly={formikProps.values.endCad === 'true' &&
                              quote.personType === 2532
                              ? true
                              : false}
                          />
                        </Col>
                        <Col md={2}>
                          <Field
                            name={fieldQuestions.numero}
                            label={fitForm.getDsQuestion(fieldQuestions.numero, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.numero, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.numero, questions)}

                            readOnly={formikProps.values.endCad === 'true' &&
                              quote.personType === 2532
                              ? true
                              : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.cidade}
                            label={fitForm.getDsQuestion(fieldQuestions.cidade, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.cidade, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.cidade, questions)}
                            readOnly={formikProps.values.endCad === 'true' &&
                              quote.personType === 2532
                              ? true
                              : false}
                          />
                        </Col>
                        <Col md={4}>
                          <Field
                            name={fieldQuestions.complemento}
                            label={fitForm.getDsQuestion(fieldQuestions.complemento, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.complemento, questions)}

                            component={fitForm.verifyComponent(fieldQuestions.complemento, questions)}
                          />
                        </Col>
                        <Col md={2}>
                          <Field
                            name={fieldQuestions.estado}
                            label={fitForm.getDsQuestion(fieldQuestions.estado, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.estado, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.estado, questions)}

                            readOnly={formikProps.values.endCad === 'true' &&
                              quote.personType === 2532
                              ? true
                              : false}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.telefone}
                            label={fitForm.getDsQuestion(fieldQuestions.telefone, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.telefone, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.telefone, questions)}

                            onChange={(value) => formikProps.setFieldValue(fieldQuestions.telefone, Mask.tel(value))}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <Field
                            name={fieldQuestions.pep}
                            label={fitForm.getDsQuestion(fieldQuestions.pep, questions)}
                            component={fitForm.verifyComponent(fieldQuestions.pep, questions)}
                            options={fitForm.verifyOptions(fieldQuestions.pep, questions)}
                            isRequired={fitForm.verifyRequired(fieldQuestions.pep, questions)}
                            tooltip="Para finalizar a contratação do seguro, você deverá informar se nos últimos 5 anos você ou algum dos seus familiares desempenhou cargo político ou posição relevante em empresas públicas do Governo Federal."
                            tooltipColor="#01AEAA"

                          />
                        </Col>
                      </Row>
                    </Fieldset>
                  </ContentCard>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col sm={12} md={12} lg={12}>
                      <Label>
                        <CheckBox
                          value={formikProps.values.confirmData}
                          checked={formikProps.values.confirmData}
                          onChange={() => handleSelect('confirmData')}
                        />
                        Confirmo que Revisei os Dados Preenchidos e Autorizo a Emissão do Seguro.
                      </Label>
                      <Row>
                        <Label>
                          <CheckBox
                            value={formikProps.values.acceptTerms}
                            checked={formikProps.values.acceptTerms}
                            onChange={() => handleSelect('acceptTerms')}
                          />
                          Concordo que Li e Aceito os
                        </Label>
                        <Label onClick={() => setShowTerms(true)}>
                          &nbsp;<u>Termos e Condições</u>&nbsp;
                        </Label>
                        <Label>
                          apresentados.
                        </Label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6} md={7} lg={8} className="px-0">
                      <ButtonContainer style={{ width: "100%", height: "100%", alignItems: "end", flexDirection: "row-reverse" }}>
                        <Button
                          fifth
                          style={{ whiteSpace: "normal", height: "auto", minHeight: "42px", paddingLeft: "1.2rem", paddingRight: "1.2rem", marginBottom: "10px" }}
                          onClick={() => handleSend()}
                        >
                          {sentCode ? "Reenviar" : "Enviar"} código de emissão para o meu e-mail
                        </Button>
                      </ButtonContainer>
                    </Col>
                    <Col xs={12} sm={6} md={5} lg={4} className="px-0 pl-sm-4">
                      <Field
                        name="verificationCode"
                        label="Inserir Código"
                        isRequired={true}
                        component={InputField}
                        onChange={(value) => { console.log(value) }}
                      />
                    </Col>
                  </Row>
                  <Row style={sentCode ? { textAlign: "center", justifyContent: "center" } : { display: "none" }}>
                    <h5 style={{ fontWeight: "normal" }}>Não recebeu o código em 30 segundos? <br className="d-block d-md-none" />Clique para reenviar o código e pronto!</h5>
                  </Row>
                  <ButtonContainer>
                    <Button onClick={() => history.goBack()} className="d-none d-sm-block p-0 p-md-2">
                      &lt; Voltar
                    </Button>
                    <Button primary type='submit'>
                      CONFIRMAR
                    </Button>
                  </ButtonContainer>
                  <ButtonContainer className="d-sm-none">
                    <Button onClick={() => history.goBack()}>
                      &lt; Voltar
                    </Button>
                  </ButtonContainer>
                </Col>
              </Row>

            </Form>
          )}
        </Formik>

      </Content>
    </Container >
  );
}
